/* eslint-disable max-lines */
import { IDistrictsStats } from '../types/district';

export const DISTRICTS_STATS: IDistrictsStats = {
  Метрогородок: {
    '1': {
      price: 6123000,
      percent: 10.7,
    },
    '2': {
      price: 7933000,
      percent: 10.9,
    },
    '3': {
      price: 10041000,
      percent: 6.9,
    },
  },
  Новогиреево: {
    '1': {
      price: 6708000,
      percent: 8.5,
    },
    '2': {
      price: 8464000,
      percent: 7.5,
    },
    '3': {
      price: 13357000,
      percent: 5.8,
    },
  },
  Новокосино: {
    '1': {
      price: 6907000,
      percent: 10.7,
    },
    '2': {
      price: 9065000,
      percent: 7.8,
    },
    '3': {
      price: 11660000,
      percent: 6.3,
    },
  },
  'Соколиная гора': {
    '1': {
      price: 7677000,
      percent: 7.8,
    },
    '2': {
      price: 11056000,
      percent: 7.3,
    },
    '3': {
      price: 15625000,
      percent: 5.8,
    },
  },
  Крылатское: {
    '1': {
      price: 9832000,
      percent: 9.8,
    },
    '2': {
      price: 14106000,
      percent: 5.0,
    },
    '3': {
      price: 20158000,
      percent: 1.0,
    },
  },
  Можайский: {
    '1': {
      price: 7674000,
      percent: 12.7,
    },
    '2': {
      price: 10907000,
      percent: 10.3,
    },
    '3': {
      price: 16430000,
      percent: 5.0,
    },
  },
  Крюково: {
    '1': {
      price: 5410000,
      percent: 12.5,
    },
    '2': {
      price: 7695000,
      percent: 10.1,
    },
    '3': {
      price: 9839000,
      percent: 7.5,
    },
  },
  Марушкинское: {
    '1': {
      price: 4649000,
      percent: 15.5,
    },
    '2': {
      price: 6571000,
      percent: 13.4,
    },
    '3': {
      price: 8158000,
      percent: 6.1,
    },
  },
  Филимонковское: {
    '1': {
      price: 4913000,
      percent: 12.2,
    },
    '2': {
      price: 6176000,
      percent: 9.1,
    },
    '3': {
      price: 7750000,
      percent: 9.4,
    },
  },
  Бабушкинский: {
    '1': {
      price: 7075000,
      percent: 7.5,
    },
    '2': {
      price: 9946000,
      percent: 8.1,
    },
    '3': {
      price: 13782000,
      percent: 5.2,
    },
  },
  Бутырский: {
    '1': {
      price: 9474000,
      percent: 12.1,
    },
    '2': {
      price: 12949000,
      percent: 11.2,
    },
    '3': {
      price: 16584000,
      percent: 8.6,
    },
  },
  Клёновское: {
    '1': {
      price: 3000000,
      percent: 7.9,
    },
    '2': {
      price: 3737000,
      percent: 7.1,
    },
    '3': {
      price: 4800000,
      percent: 12.6,
    },
  },
  Троицк: {
    '1': {
      price: 5405000,
      percent: 13.1,
    },
    '2': {
      price: 7517000,
      percent: 12.2,
    },
    '3': {
      price: 9650000,
      percent: 10.9,
    },
  },
  Арбат: {
    '1': {
      price: 15200000,
      percent: 5.1,
    },
    '2': {
      price: 20819000,
      percent: 1.3,
    },
    '3': {
      price: 30588000,
      percent: 1.0,
    },
  },
  Таганский: {
    '1': {
      price: 10102000,
      percent: 8.3,
    },
    '2': {
      price: 15004000,
      percent: 6.1,
    },
    '3': {
      price: 23404000,
      percent: 4.2,
    },
  },
  Хамовники: {
    '1': {
      price: 13792000,
      percent: 6.0,
    },
    '2': {
      price: 20072000,
      percent: 3.9,
    },
    '3': {
      price: 29835000,
      percent: 3.6,
    },
  },
  Даниловский: {
    '1': {
      price: 9487000,
      percent: 7.5,
    },
    '2': {
      price: 13798000,
      percent: 6.3,
    },
    '3': {
      price: 26294000,
      percent: 8.3,
    },
  },
  'Нагатино-Садовники': {
    '1': {
      price: 8031000,
      percent: 8.6,
    },
    '2': {
      price: 11204000,
      percent: 7.3,
    },
    '3': {
      price: 16415000,
      percent: 4.5,
    },
  },
  'Орехово-Борисово Южное': {
    '1': {
      price: 6736000,
      percent: 11.3,
    },
    '2': {
      price: 9092000,
      percent: 9.6,
    },
    '3': {
      price: 11199000,
      percent: 10.1,
    },
  },
  Царицыно: {
    '1': {
      price: 6620000,
      percent: 9.4,
    },
    '2': {
      price: 8296000,
      percent: 9.8,
    },
    '3': {
      price: 11073000,
      percent: 8.4,
    },
  },
  'Чертаново Центральное': {
    '1': {
      price: 7141000,
      percent: 9.3,
    },
    '2': {
      price: 9052000,
      percent: 8.4,
    },
    '3': {
      price: 12828000,
      percent: 6.7,
    },
  },
  Кузьминки: {
    '1': {
      price: 6487000,
      percent: 9.2,
    },
    '2': {
      price: 8368000,
      percent: 8.1,
    },
    '3': {
      price: 13480000,
      percent: 7.4,
    },
  },
  Люблино: {
    '1': {
      price: 6524000,
      percent: 9.6,
    },
    '2': {
      price: 8842000,
      percent: 8.4,
    },
    '3': {
      price: 11278000,
      percent: 6.3,
    },
  },
  Некрасовка: {
    '1': {
      price: 5804000,
      percent: 12.6,
    },
    '2': {
      price: 7935000,
      percent: 11.3,
    },
    '3': {
      price: 9954000,
      percent: 10.0,
    },
  },
  'Южное Бутово': {
    '1': {
      price: 6555000,
      percent: 10.0,
    },
    '2': {
      price: 9118000,
      percent: 8.9,
    },
    '3': {
      price: 11421000,
      percent: 5.9,
    },
  },
  'Косино-Ухтомский': {
    '1': {
      price: 6370000,
      percent: 9.7,
    },
    '2': {
      price: 8856000,
      percent: 8.2,
    },
    '3': {
      price: 12093000,
      percent: 7.0,
    },
  },
  'Северное Измайлово': {
    '1': {
      price: 6540000,
      percent: 10.7,
    },
    '2': {
      price: 8545000,
      percent: 9.3,
    },
    '3': {
      price: 12484000,
      percent: 7.0,
    },
  },
  Внуково: {
    '1': {
      price: 5353000,
      percent: 13.7,
    },
    '2': {
      price: 7111000,
      percent: 11.9,
    },
    '3': {
      price: 8286000,
      percent: 7.6,
    },
  },
  'Очаково-Матвеевское': {
    '1': {
      price: 8594000,
      percent: 10.5,
    },
    '2': {
      price: 13160000,
      percent: 7.1,
    },
    '3': {
      price: 22039000,
      percent: 3.3,
    },
  },
  'Проспект Вернадского': {
    '1': {
      price: 9788000,
      percent: 8.3,
    },
    '2': {
      price: 14796000,
      percent: 6.1,
    },
    '3': {
      price: 25518000,
      percent: 2.2,
    },
  },
  Раменки: {
    '1': {
      price: 11594000,
      percent: 5.5,
    },
    '2': {
      price: 18893000,
      percent: 3.8,
    },
    '3': {
      price: 32576000,
      percent: 2.3,
    },
  },
  Кокошкино: {
    '1': {
      price: 5038000,
      percent: 13.8,
    },
    '2': {
      price: 6240000,
      percent: 12.5,
    },
    '3': {
      price: 9366000,
      percent: 9.5,
    },
  },
  Мосрентген: {
    '1': {
      price: 5938000,
      percent: 13.7,
    },
    '2': {
      price: 8500000,
      percent: 9.9,
    },
    '3': {
      price: 10577000,
      percent: 11.1,
    },
  },
  Рязановское: {
    '1': {
      price: 5337000,
      percent: 10.4,
    },
    '2': {
      price: 7341000,
      percent: 13.4,
    },
    '3': {
      price: 8853000,
      percent: 8.2,
    },
  },
  Щербинка: {
    '1': {
      price: 5436000,
      percent: 13.4,
    },
    '2': {
      price: 7142000,
      percent: 11.6,
    },
    '3': {
      price: 8907000,
      percent: 10.8,
    },
  },
  Аэропорт: {
    '1': {
      price: 8753000,
      percent: 6.9,
    },
    '2': {
      price: 13021000,
      percent: 5.2,
    },
    '3': {
      price: 24255000,
      percent: 4.0,
    },
  },
  Молжаниновский: {
    '1': {
      price: 5548000,
      percent: 11.8,
    },
    '2': {
      price: 7161000,
      percent: 10.4,
    },
    '3': {
      price: 9200000,
      percent: 7.0,
    },
  },
  Ховрино: {
    '1': {
      price: 7293000,
      percent: 10.1,
    },
    '2': {
      price: 10752000,
      percent: 7.8,
    },
    '3': {
      price: 14788000,
      percent: 5.9,
    },
  },
  Хорошевский: {
    '1': {
      price: 12002000,
      percent: 8.7,
    },
    '2': {
      price: 17849000,
      percent: 6.6,
    },
    '3': {
      price: 28633000,
      percent: 1.4,
    },
  },
  Отрадное: {
    '1': {
      price: 7423000,
      percent: 9.8,
    },
    '2': {
      price: 9371000,
      percent: 6.6,
    },
    '3': {
      price: 11918000,
      percent: 5.5,
    },
  },
  Новофёдоровское: {
    '1': {
      price: 3465000,
      percent: 14.5,
    },
    '2': {
      price: 4625000,
      percent: 16.7,
    },
    '3': {
      price: 6174000,
      percent: 0.2,
    },
  },
  Первомайское: {
    '1': {
      price: 3800000,
      percent: 9.0,
    },
    '2': {
      price: 5942000,
      percent: 14.0,
    },
    '3': {
      price: 7608000,
      percent: 7.9,
    },
  },
  Роговское: {
    '1': {
      price: 2500000,
      percent: 6.5,
    },
    '2': {
      price: 3000000,
      percent: 8.5,
    },
    '3': {
      price: 4500000,
      percent: 5.3,
    },
  },
  Басманный: {
    '1': {
      price: 11031000,
      percent: 8.0,
    },
    '2': {
      price: 16729000,
      percent: 6.4,
    },
    '3': {
      price: 24946000,
      percent: 5.3,
    },
  },
  Замоскворечье: {
    '1': {
      price: 13958000,
      percent: 8.4,
    },
    '2': {
      price: 20851000,
      percent: 7.4,
    },
    '3': {
      price: 43231000,
      percent: 6.3,
    },
  },
  Красносельский: {
    '1': {
      price: 11926000,
      percent: 6.9,
    },
    '2': {
      price: 16538000,
      percent: 7.1,
    },
    '3': {
      price: 25145000,
      percent: 4.4,
    },
  },
  Братеево: {
    '1': {
      price: 6735000,
      percent: 9.0,
    },
    '2': {
      price: 9187000,
      percent: 8.7,
    },
    '3': {
      price: 11810000,
      percent: 7.0,
    },
  },
  'Нагатинский затон': {
    '1': {
      price: 8361000,
      percent: 9.8,
    },
    '2': {
      price: 11358000,
      percent: 9.5,
    },
    '3': {
      price: 15004000,
      percent: 7.4,
    },
  },
  'Чертаново Южное': {
    '1': {
      price: 7039000,
      percent: 9.3,
    },
    '2': {
      price: 9654000,
      percent: 9.7,
    },
    '3': {
      price: 12566000,
      percent: 7.8,
    },
  },
  Капотня: {
    '1': {
      price: 5341000,
      percent: 12.2,
    },
    '2': {
      price: 7036000,
      percent: 11.8,
    },
    '3': {
      price: 9214000,
      percent: 7.4,
    },
  },
  Лефортово: {
    '1': {
      price: 9432000,
      percent: 11.9,
    },
    '2': {
      price: 13244000,
      percent: 9.0,
    },
    '3': {
      price: 17584000,
      percent: 8.4,
    },
  },
  Нижегородский: {
    '1': {
      price: 7021000,
      percent: 10.1,
    },
    '2': {
      price: 9943000,
      percent: 8.5,
    },
    '3': {
      price: 12725000,
      percent: 7.0,
    },
  },
  Текстильщики: {
    '1': {
      price: 6457000,
      percent: 8.3,
    },
    '2': {
      price: 8535000,
      percent: 8.3,
    },
    '3': {
      price: 10961000,
      percent: 5.9,
    },
  },
  Коньково: {
    '1': {
      price: 7820000,
      percent: 9.4,
    },
    '2': {
      price: 11023000,
      percent: 8.0,
    },
    '3': {
      price: 13845000,
      percent: 4.3,
    },
  },
  'Теплый Стан': {
    '1': {
      price: 7577000,
      percent: 8.4,
    },
    '2': {
      price: 10573000,
      percent: 5.8,
    },
    '3': {
      price: 14683000,
      percent: 4.4,
    },
  },
  Богородское: {
    '1': {
      price: 7007000,
      percent: 9.3,
    },
    '2': {
      price: 10056000,
      percent: 8.3,
    },
    '3': {
      price: 13633000,
      percent: 8.5,
    },
  },
  Восточный: {
    '1': {
      price: 4778000,
      percent: 10.7,
    },
    '2': {
      price: 6488000,
      percent: 7.9,
    },
    '3': {
      price: 8111000,
      percent: 5.9,
    },
  },
  Гольяново: {
    '1': {
      price: 6226000,
      percent: 9.9,
    },
    '2': {
      price: 7864000,
      percent: 8.5,
    },
    '3': {
      price: 10511000,
      percent: 7.9,
    },
  },
  Солнцево: {
    '1': {
      price: 7280000,
      percent: 13.5,
    },
    '2': {
      price: 9632000,
      percent: 11.0,
    },
    '3': {
      price: 12857000,
      percent: 9.9,
    },
  },
  Силино: {
    '1': {
      price: 5376000,
      percent: 11.4,
    },
    '2': {
      price: 6973000,
      percent: 8.3,
    },
    '3': {
      price: 9424000,
      percent: 8.7,
    },
  },
  Десёновское: {
    '1': {
      price: 5473000,
      percent: 14.1,
    },
    '2': {
      price: 7694000,
      percent: 12.5,
    },
    '3': {
      price: 9908000,
      percent: 14.0,
    },
  },
  Московский: {
    '1': {
      price: 8144000,
      percent: 13.9,
    },
    '2': {
      price: 11078000,
      percent: 11.8,
    },
    '3': {
      price: 15159000,
      percent: 12.1,
    },
  },
  Сосенское: {
    '1': {
      price: 6610000,
      percent: 12.5,
    },
    '2': {
      price: 9142000,
      percent: 10.3,
    },
    '3': {
      price: 12582000,
      percent: 8.0,
    },
  },
  Беговой: {
    '1': {
      price: 11791000,
      percent: 13.4,
    },
    '2': {
      price: 16882000,
      percent: 10.2,
    },
    '3': {
      price: 23610000,
      percent: 8.2,
    },
  },
  Дмитровский: {
    '1': {
      price: 6834000,
      percent: 13.2,
    },
    '2': {
      price: 9404000,
      percent: 10.4,
    },
    '3': {
      price: 12709000,
      percent: 8.8,
    },
  },
  'Западное Дегунино': {
    '1': {
      price: 6835000,
      percent: 10.9,
    },
    '2': {
      price: 9178000,
      percent: 10.2,
    },
    '3': {
      price: 11959000,
      percent: 7.7,
    },
  },
  Тимирязевский: {
    '1': {
      price: 7883000,
      percent: 8.9,
    },
    '2': {
      price: 11364000,
      percent: 8.2,
    },
    '3': {
      price: 20300000,
      percent: 7.9,
    },
  },
  Бибирево: {
    '1': {
      price: 6772000,
      percent: 9.7,
    },
    '2': {
      price: 8389000,
      percent: 7.8,
    },
    '3': {
      price: 10459000,
      percent: 7.0,
    },
  },
  'Марьина роща': {
    '1': {
      price: 9083000,
      percent: 7.7,
    },
    '2': {
      price: 12200000,
      percent: 6.1,
    },
    '3': {
      price: 19200000,
      percent: 5.3,
    },
  },
  Останкинский: {
    '1': {
      price: 8439000,
      percent: 9.2,
    },
    '2': {
      price: 12212000,
      percent: 7.7,
    },
    '3': {
      price: 18904000,
      percent: 2.9,
    },
  },
  Ростокино: {
    '1': {
      price: 8050000,
      percent: 9.6,
    },
    '2': {
      price: 11978000,
      percent: 9.4,
    },
    '3': {
      price: 19966000,
      percent: 3.7,
    },
  },
  'Северное Медведково': {
    '1': {
      price: 6983000,
      percent: 8.8,
    },
    '2': {
      price: 9322000,
      percent: 7.3,
    },
    '3': {
      price: 11971000,
      percent: 6.0,
    },
  },
  'Южное Медведково': {
    '1': {
      price: 7054000,
      percent: 9.3,
    },
    '2': {
      price: 10189000,
      percent: 6.7,
    },
    '3': {
      price: 12582000,
      percent: 3.7,
    },
  },
  Ярославский: {
    '1': {
      price: 5996000,
      percent: 9.5,
    },
    '2': {
      price: 7924000,
      percent: 7.9,
    },
    '3': {
      price: 10826000,
      percent: 7.4,
    },
  },
  'Северное Тушино': {
    '1': {
      price: 7045000,
      percent: 9.6,
    },
    '2': {
      price: 9365000,
      percent: 8.1,
    },
    '3': {
      price: 12161000,
      percent: 7.0,
    },
  },
  'Хорошево-Мневники': {
    '1': {
      price: 9607000,
      percent: 12.3,
    },
    '2': {
      price: 14087000,
      percent: 8.7,
    },
    '3': {
      price: 23609000,
      percent: 8.2,
    },
  },
  Щукино: {
    '1': {
      price: 8586000,
      percent: 8.3,
    },
    '2': {
      price: 13561000,
      percent: 6.3,
    },
    '3': {
      price: 25819000,
      percent: 2.3,
    },
  },
  Щаповское: {
    '1': {
      price: 4452000,
      percent: 13.5,
    },
    '2': {
      price: 5090000,
      percent: 11.0,
    },
    '3': {
      price: 6316000,
      percent: 10.5,
    },
  },
  Мещанский: {
    '1': {
      price: 10784000,
      percent: 6.8,
    },
    '2': {
      price: 15607000,
      percent: 4.6,
    },
    '3': {
      price: 23653000,
      percent: 3.7,
    },
  },
  Тверской: {
    '1': {
      price: 13631000,
      percent: 7.0,
    },
    '2': {
      price: 20010000,
      percent: 3.7,
    },
    '3': {
      price: 31928000,
      percent: 3.3,
    },
  },
  'Бирюлево Восточное': {
    '1': {
      price: 6294000,
      percent: 10.5,
    },
    '2': {
      price: 8800000,
      percent: 9.5,
    },
    '3': {
      price: 11438000,
      percent: 6.7,
    },
  },
  Донской: {
    '1': {
      price: 8529000,
      percent: 8.5,
    },
    '2': {
      price: 15127000,
      percent: 8.0,
    },
    '3': {
      price: 25103000,
      percent: 7.3,
    },
  },
  Марьино: {
    '1': {
      price: 6843000,
      percent: 9.0,
    },
    '2': {
      price: 9572000,
      percent: 7.2,
    },
    '3': {
      price: 12402000,
      percent: 5.8,
    },
  },
  Академический: {
    '1': {
      price: 10902000,
      percent: 11.7,
    },
    '2': {
      price: 15083000,
      percent: 8.5,
    },
    '3': {
      price: 22002000,
      percent: 6.4,
    },
  },
  Гагаринский: {
    '1': {
      price: 10578000,
      percent: 6.6,
    },
    '2': {
      price: 15634000,
      percent: 3.9,
    },
    '3': {
      price: 24404000,
      percent: 2.1,
    },
  },
  Зюзино: {
    '1': {
      price: 7800000,
      percent: 9.3,
    },
    '2': {
      price: 10552000,
      percent: 8.5,
    },
    '3': {
      price: 16463000,
      percent: 6.2,
    },
  },
  Ломоносовский: {
    '1': {
      price: 9838000,
      percent: 8.0,
    },
    '2': {
      price: 14447000,
      percent: 6.3,
    },
    '3': {
      price: 24036000,
      percent: 4.6,
    },
  },
  Обручевский: {
    '1': {
      price: 10492000,
      percent: 10.7,
    },
    '2': {
      price: 16788000,
      percent: 7.1,
    },
    '3': {
      price: 26174000,
      percent: 6.2,
    },
  },
  Ясенево: {
    '1': {
      price: 6668000,
      percent: 8.0,
    },
    '2': {
      price: 9901000,
      percent: 7.0,
    },
    '3': {
      price: 13338000,
      percent: 8.6,
    },
  },
  Вешняки: {
    '1': {
      price: 5950000,
      percent: 10.5,
    },
    '2': {
      price: 8148000,
      percent: 10.1,
    },
    '3': {
      price: 9721000,
      percent: 8.5,
    },
  },
  Перово: {
    '1': {
      price: 6596000,
      percent: 10.0,
    },
    '2': {
      price: 8475000,
      percent: 9.2,
    },
    '3': {
      price: 12250000,
      percent: 6.6,
    },
  },
  Преображенское: {
    '1': {
      price: 7818000,
      percent: 9.0,
    },
    '2': {
      price: 10969000,
      percent: 8.7,
    },
    '3': {
      price: 16289000,
      percent: 5.5,
    },
  },
  Кунцево: {
    '1': {
      price: 9360000,
      percent: 9.6,
    },
    '2': {
      price: 14281000,
      percent: 9.7,
    },
    '3': {
      price: 21019000,
      percent: 5.4,
    },
  },
  'Фили-Давыдково': {
    '1': {
      price: 8966000,
      percent: 8.7,
    },
    '2': {
      price: 13092000,
      percent: 6.3,
    },
    '3': {
      price: 22328000,
      percent: 2.9,
    },
  },
  Матушкино: {
    '1': {
      price: 5339000,
      percent: 10.6,
    },
    '2': {
      price: 6873000,
      percent: 9.4,
    },
    '3': {
      price: 9510000,
      percent: 4.5,
    },
  },
  Савёлки: {
    '1': {
      price: 5486000,
      percent: 6.5,
    },
    '2': {
      price: 7221000,
      percent: 2.9,
    },
    '3': {
      price: 12357000,
      percent: 1.4,
    },
  },
  'Старое Крюково': {
    '1': {
      price: 5366000,
      percent: 10.9,
    },
    '2': {
      price: 6789000,
      percent: 9.7,
    },
    '3': {
      price: 8553000,
      percent: 9.2,
    },
  },
  Внуковское: {
    '1': {
      price: 7024000,
      percent: 14.0,
    },
    '2': {
      price: 9586000,
      percent: 11.6,
    },
    '3': {
      price: 12459000,
      percent: 11.1,
    },
  },
  Воскресенское: {
    '1': {
      price: 6059000,
      percent: 13.9,
    },
    '2': {
      price: 8000000,
      percent: 13.0,
    },
    '3': {
      price: 11000000,
      percent: 11.3,
    },
  },
  Бескудниковский: {
    '1': {
      price: 6962000,
      percent: 9.3,
    },
    '2': {
      price: 10675000,
      percent: 10.0,
    },
    '3': {
      price: 13971000,
      percent: 7.8,
    },
  },
  Войковский: {
    '1': {
      price: 8972000,
      percent: 9.8,
    },
    '2': {
      price: 12309000,
      percent: 8.9,
    },
    '3': {
      price: 17598000,
      percent: 6.1,
    },
  },
  'Восточное Дегунино': {
    '1': {
      price: 6731000,
      percent: 9.4,
    },
    '2': {
      price: 9126000,
      percent: 9.8,
    },
    '3': {
      price: 12105000,
      percent: 8.5,
    },
  },
  Головинский: {
    '1': {
      price: 7818000,
      percent: 10.7,
    },
    '2': {
      price: 9975000,
      percent: 12.3,
    },
    '3': {
      price: 13617000,
      percent: 8.1,
    },
  },
  Коптево: {
    '1': {
      price: 7244000,
      percent: 9.5,
    },
    '2': {
      price: 9734000,
      percent: 8.0,
    },
    '3': {
      price: 14359000,
      percent: 6.2,
    },
  },
  Левобережный: {
    '1': {
      price: 8007000,
      percent: 9.9,
    },
    '2': {
      price: 10908000,
      percent: 8.3,
    },
    '3': {
      price: 15726000,
      percent: 6.6,
    },
  },
  Сокол: {
    '1': {
      price: 8430000,
      percent: 6.3,
    },
    '2': {
      price: 14046000,
      percent: 6.3,
    },
    '3': {
      price: 20524000,
      percent: 3.5,
    },
  },
  Лианозово: {
    '1': {
      price: 6995000,
      percent: 8.5,
    },
    '2': {
      price: 9670000,
      percent: 8.0,
    },
    '3': {
      price: 11753000,
      percent: 6.0,
    },
  },
  Лосиноостровский: {
    '1': {
      price: 6711000,
      percent: 9.5,
    },
    '2': {
      price: 8450000,
      percent: 8.6,
    },
    '3': {
      price: 12409000,
      percent: 4.8,
    },
  },
  Свиблово: {
    '1': {
      price: 8213000,
      percent: 8.8,
    },
    '2': {
      price: 11585000,
      percent: 9.5,
    },
    '3': {
      price: 15435000,
      percent: 7.0,
    },
  },
  Куркино: {
    '1': {
      price: 9120000,
      percent: 5.6,
    },
    '2': {
      price: 13483000,
      percent: 5.8,
    },
    '3': {
      price: 19563000,
      percent: 5.3,
    },
  },
  Митино: {
    '1': {
      price: 7390000,
      percent: 7.9,
    },
    '2': {
      price: 10355000,
      percent: 6.3,
    },
    '3': {
      price: 13254000,
      percent: 6.1,
    },
  },
  Строгино: {
    '1': {
      price: 8284000,
      percent: 7.1,
    },
    '2': {
      price: 11520000,
      percent: 5.3,
    },
    '3': {
      price: 17009000,
      percent: 3.2,
    },
  },
  'Южное Тушино': {
    '1': {
      price: 7039000,
      percent: 9.2,
    },
    '2': {
      price: 9571000,
      percent: 7.1,
    },
    '3': {
      price: 16286000,
      percent: 6.3,
    },
  },
  Киевский: {
    '1': {
      price: 3955000,
      percent: 10.3,
    },
    '2': {
      price: 4400000,
      percent: 6.0,
    },
    '3': {
      price: 5333000,
      percent: 7.3,
    },
  },
  'Михайлово-Ярцевское': {
    '1': {
      price: 3692000,
      percent: 11.1,
    },
    '2': {
      price: 5150000,
      percent: 15.5,
    },
    '3': {
      price: 5333000,
      percent: 10.5,
    },
  },
  Пресненский: {
    '1': {
      price: 14897000,
      percent: 10.5,
    },
    '2': {
      price: 20882000,
      percent: 8.2,
    },
    '3': {
      price: 29401000,
      percent: 4.6,
    },
  },
  Якиманка: {
    '1': {
      price: 12302000,
      percent: 6.4,
    },
    '2': {
      price: 20376000,
      percent: 7.0,
    },
    '3': {
      price: 31770000,
      percent: 0.1,
    },
  },
  'Бирюлево Западное': {
    '1': {
      price: 5435000,
      percent: 10.4,
    },
    '2': {
      price: 6623000,
      percent: 9.8,
    },
    '3': {
      price: 8336000,
      percent: 6.8,
    },
  },
  'Москворечье-Сабурово': {
    '1': {
      price: 7186000,
      percent: 8.0,
    },
    '2': {
      price: 10041000,
      percent: 6.8,
    },
    '3': {
      price: 13490000,
      percent: 4.2,
    },
  },
  Нагорный: {
    '1': {
      price: 7603000,
      percent: 7.5,
    },
    '2': {
      price: 11150000,
      percent: 7.6,
    },
    '3': {
      price: 15911000,
      percent: 5.4,
    },
  },
  'Орехово-Борисово Северное': {
    '1': {
      price: 6784000,
      percent: 9.9,
    },
    '2': {
      price: 9071000,
      percent: 7.9,
    },
    '3': {
      price: 11427000,
      percent: 6.6,
    },
  },
  'Чертаново Северное': {
    '1': {
      price: 7316000,
      percent: 9.6,
    },
    '2': {
      price: 10197000,
      percent: 7.3,
    },
    '3': {
      price: 16816000,
      percent: 4.2,
    },
  },
  'Выхино-Жулебино': {
    '1': {
      price: 6368000,
      percent: 9.6,
    },
    '2': {
      price: 8316000,
      percent: 8.7,
    },
    '3': {
      price: 11588000,
      percent: 6.9,
    },
  },
  Рязанский: {
    '1': {
      price: 6857000,
      percent: 9.5,
    },
    '2': {
      price: 9647000,
      percent: 8.2,
    },
    '3': {
      price: 13404000,
      percent: 8.0,
    },
  },
  Южнопортовый: {
    '1': {
      price: 9289000,
      percent: 7.9,
    },
    '2': {
      price: 12767000,
      percent: 5.8,
    },
    '3': {
      price: 19279000,
      percent: 4.0,
    },
  },
  'Восточное Измайлово': {
    '1': {
      price: 6920000,
      percent: 10.7,
    },
    '2': {
      price: 9122000,
      percent: 7.4,
    },
    '3': {
      price: 14481000,
      percent: 9.9,
    },
  },
  Ивановское: {
    '1': {
      price: 6206000,
      percent: 9.8,
    },
    '2': {
      price: 7750000,
      percent: 8.7,
    },
    '3': {
      price: 9910000,
      percent: 6.3,
    },
  },
  Измайлово: {
    '1': {
      price: 6924000,
      percent: 8.4,
    },
    '2': {
      price: 9719000,
      percent: 3.8,
    },
    '3': {
      price: 15458000,
      percent: 1.1,
    },
  },
  Сокольники: {
    '1': {
      price: 9016000,
      percent: 7.9,
    },
    '2': {
      price: 13188000,
      percent: 3.9,
    },
    '3': {
      price: 22378000,
      percent: 6.0,
    },
  },
  Дорогомилово: {
    '1': {
      price: 11602000,
      percent: 8.0,
    },
    '2': {
      price: 18867000,
      percent: 3.4,
    },
    '3': {
      price: 24485000,
      percent: 3.6,
    },
  },
  'Ново-Переделкино': {
    '1': {
      price: 6705000,
      percent: 11.7,
    },
    '2': {
      price: 8815000,
      percent: 8.8,
    },
    '3': {
      price: 11739000,
      percent: 8.6,
    },
  },
  'Тропарево-Никулино': {
    '1': {
      price: 12304000,
      percent: 3.0,
    },
    '2': {
      price: 16588000,
      percent: 2.7,
    },
    '3': {
      price: 28860000,
      percent: 2.2,
    },
  },
  'Филевский парк': {
    '1': {
      price: 10169000,
      percent: 13.4,
    },
    '2': {
      price: 15889000,
      percent: 10.5,
    },
    '3': {
      price: 20287000,
      percent: 8.9,
    },
  },
  Савеловский: {
    '1': {
      price: 8548000,
      percent: 7.6,
    },
    '2': {
      price: 11238000,
      percent: 6.8,
    },
    '3': {
      price: 19464000,
      percent: 6.2,
    },
  },
  Алексеевский: {
    '1': {
      price: 8422000,
      percent: 7.9,
    },
    '2': {
      price: 12834000,
      percent: 7.2,
    },
    '3': {
      price: 20232000,
      percent: 7.0,
    },
  },
  Алтуфьевский: {
    '1': {
      price: 6901000,
      percent: 11.5,
    },
    '2': {
      price: 8679000,
      percent: 10.1,
    },
    '3': {
      price: 10685000,
      percent: 5.8,
    },
  },
  Марфино: {
    '1': {
      price: 8141000,
      percent: 10.1,
    },
    '2': {
      price: 11628000,
      percent: 6.5,
    },
    '3': {
      price: 15583000,
      percent: 5.0,
    },
  },
  Северный: {
    '1': {
      price: 6401000,
      percent: 12.9,
    },
    '2': {
      price: 9118000,
      percent: 11.8,
    },
    '3': {
      price: 11088000,
      percent: 9.6,
    },
  },
  'Покровское-Стрешнево': {
    '1': {
      price: 7746000,
      percent: 9.6,
    },
    '2': {
      price: 11583000,
      percent: 7.1,
    },
    '3': {
      price: 18322000,
      percent: 4.9,
    },
  },
  Вороновское: {
    '1': {
      price: 3167000,
      percent: 7.3,
    },
    '2': {
      price: 4227000,
      percent: 9.3,
    },
    '3': {
      price: 6286000,
      percent: 9.5,
    },
  },
  Краснопахорское: {
    '1': {
      price: 4286000,
      percent: 12.9,
    },
    '2': {
      price: 5607000,
      percent: 12.2,
    },
    '3': {
      price: 6000000,
      percent: 8.4,
    },
  },
  Зябликово: {
    '1': {
      price: 6547000,
      percent: 8.9,
    },
    '2': {
      price: 8406000,
      percent: 6.3,
    },
    '3': {
      price: 10729000,
      percent: 6.4,
    },
  },
  Печатники: {
    '1': {
      price: 6598000,
      percent: 9.5,
    },
    '2': {
      price: 8339000,
      percent: 8.8,
    },
    '3': {
      price: 11482000,
      percent: 8.3,
    },
  },
};
